import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import BaiduMap from 'vue-baidu-map';
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'boxicons/css/boxicons.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faHome, faUser, faBell } from '@fortawesome/free-solid-svg-icons'; // 导入你需要的图标
import './assets/main.css';
import { modelLoader } from '@/utils/ModelLoader.js';//全局挂载模型预加载

// 进入 SPA 后立即预加载模型（只执行一次）
modelLoader.preloadAllModels();


Vue.config.productionTip = false;
Vue.use(Vuesax);
new Vue({
  router, //挂载路由
  render: h => h(App),
}).$mount('#app');

// 将 BMapGL 设置为全局变量，使其可以在所有组件中使用
//Vue.prototype.$BMapGL = window.BMapGL;

Vue.use(BaiduMap, {
  ak: 'vlPWRTBT0wHUFEJKKTuUAGN6MRAwpAmQ' ,// 这里替换为你的百度地图密钥
  //type:'BMapGL'
});

// 设置 axios 请求拦截器
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token'); // 从 localStorage 中获取 token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // 在请求头中添加 Authorization
  }
  return config;
}, error => {
  return Promise.reject(error); // 如果请求出错，返回错误
});




library.add(faHome, faUser, faBell);
// 注册 FontAwesomeIcon 组件
Vue.component('font-awesome-icon', FontAwesomeIcon);

